import React from 'react';
import styles from './index.less';
import TemplateTopicMenu, { ITopic }
    from '@src/slide/application/service/change-template-service/component/template-select-list/template-topic-menu';
import { getPptTemplateDetail } from '@com/tool-bar/menu/utils';
import TemplateDetailList
    from '@src/slide/application/service/change-template-service/component/template-select-list/template-detail-list';
import {
    ITemplateSelectListProps,
    ITemplateSelectListState,
    Item, SearchResult, MetaOfTemplate,
} from '@src/slide/application/service/change-template-service/index.interface';
import {
    IGNORE_TEMPLATE,
} from '@src/slide/application/service/change-template-service/component/template-select-list/filter.config';


export class TemplateSelectList extends React.Component<ITemplateSelectListProps, ITemplateSelectListState> {
    public scrollContainerRef: HTMLDivElement | null;

    public constructor(props: ITemplateSelectListProps) {
        super(props);
        this.state = {
            selectedTopicId: '',
            topicList: [],
            detailList: this.props.changeTemplateService.detailList,
            searchKey: '',
        };
    }

    public componentDidUpdate(
        prevProps: Readonly<ITemplateSelectListProps>,
        prevState: Readonly<ITemplateSelectListState>,
    ) {
        if (
            this.state.selectedTopicId !== prevState.selectedTopicId
            || this.state.searchKey !== prevState.searchKey
        ) {
            this.scrollToTop();
        }
    }

    public render() {
        return <div className={styles['template-select-container']}>
            <TemplateTopicMenu
                selectedTopicId={this.state.selectedTopicId}
                onTopicSelect={this.handleTopicSelect}
                onTopicInit={this.handleTopicInit}
                onSearch={this.handleSearch}
            />
            <div
                ref={ref => this.scrollContainerRef = ref}
                className={styles['template-detail-list-container']}>
                <TemplateDetailList
                    selectedTemplateId={this.props.selectedTemplateId}
                    isLoading={this.props.isLoading}
                    onBack={this.handleBack}
                    selectedTopicId={this.state.selectedTopicId}
                    onMoreClick={this.handleTopicSelect}
                    detailList={this.state.detailList}
                    searchKey={this.state.searchKey}
                    onClick={this.props.onTemplateSelect}
                />
            </div>
        </div>;
    }

    private handleTopicInit = async (newTopicList?: ITopic[]) => {
        const topicList = newTopicList?.filter?.(topic => !!topic.topicId) || [];
        const topicIds = topicList.map(topic => topic.topicId);

        if (this.state.detailList.length === 0) {
            const detailList = await getPptTemplateDetail(topicIds) as SearchResult[];
            const idMap = {};

            detailList.forEach((res) => {
                const { items } = res;
                const newItems = items.filter((item) => {
                    const { id } = item;

                    if (idMap[id]) {
                        return false;
                    }

                    if (IGNORE_TEMPLATE[id]) {
                        return false;
                    }

                    const img = this.getCoverSrc(this.getValidMeta(item.metaOfEachType));
                    if (!img?.startsWith('http')) {
                        return false;
                    }

                    idMap[id] = true;
                    return true;
                });

                res.items = newItems;
            });


            this.setState({
                topicList,
                detailList,
            });
            this.props.changeTemplateService.detailList = detailList;
        }
    };

    private scrollToTop = () => {
        if (this.scrollContainerRef) {
            this.scrollContainerRef.scrollTop = 0;
        }
    };

    private handleBack = () => {
        this.setState({
            selectedTopicId: '',
            searchKey: '',
        });
    };

    private handleTopicSelect = (selectedTopicId: string) => {
        this.setState({
            selectedTopicId,
            searchKey: '',
        });
    };

    private handleSearch = (searchKey: string) => {
        this.setState({
            selectedTopicId: '',
            searchKey,
        });
    };

    private getCoverSrc = (metaData: Partial<MetaOfTemplate>): string | undefined => metaData?.images?.pc_thumb_2x.url
        || metaData?.images?.pc_preview.url
        || metaData?.images?.mobile_thumb_2x.url;

    private getValidMeta = (metaOfEachType: string): Partial<MetaOfTemplate> => {
        try {
            const meta = metaOfEachType ? JSON.parse(metaOfEachType) : {};
            return meta;
        } catch (e) {
            window.log.error('getValidMeta err', e);
            return {};
        }
    };
}
